<template>
  <ik-image
    loading="lazy"
    :transformation="[{ height: height, width: width }]"
    v-if="profileImageUrl"
    :src="profileImageUrl"
    class="image"
    :style="getImageStyle"
  />
  <div v-else class="image smallBorder" :style="getImageStyle">
    <IconBase
      icon-name="profile"
      iconColor="#2c2c2d"
      viewBox="0 0 32 32"
      width="100%"
      height="100%"
      strokeWidth="0px"
      ><IconProfileImg
    /></IconBase>
  </div>
</template>

<script>
import IconBase from "./IconBase";
import IconProfileImg from "./SVG/IconProfileImg";

export default {
  name: "ProfileImage",
  props: [
    "profileImageUrl",
    "height",
    "width",
    "imageHeight",
    "imageWidth",
    "marginRight",
  ],
  components: {
    IconBase,
    IconProfileImg,
  },
  computed: {
    getImageStyle() {
      return `height: ${this.imageHeight}px !important; width: ${this.imageWidth}px !important; margin-right: ${this.marginRight}px;`;
    },
  },
};
</script>

<style scoped>
.image {
  border-radius: 360px;
  border: 2px solid #efefef;
  z-index: 999;
  /* box-sizing: border-box; */
  -o-object-fit: cover;
  object-fit: cover;
}
</style>